import { actions, initialState } from "./state";

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.CHANGE_RAWAT_JALAN:
      return {
        ...state,
        rawat_jalan: action.payload,
      };
    case actions.CHANGE_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case actions.CHANGE_ANTREAN_JKN:
      return {
        ...state,
        antrean_jkn: action.payload,
      };
    case actions.CHANGE_LOADING_ANTREAN_JKN:
      return {
        ...state,
        loading_antrean_jkn: action.payload,
      };

    default:
      return state;
  }
};
